import { render, staticRenderFns } from "./AuthModals.vue?vue&type=template&id=623bb38f"
import script from "./AuthModals.vue?vue&type=script&lang=js"
export * from "./AuthModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports